<template>
  <div class="home-container">
    <!-- 增强背景层 -->
    <div class="bg-layer-1"></div>
    <div class="bg-layer-2"></div>
    <div class="bg-layer-3"></div>
    
    <!-- 动态粒子效果 -->
    <div class="particles">
      <div class="particle" v-for="i in 30" :key="i" :style="getParticleStyle(i)"></div>
    </div>

    <!-- 网格背景 -->
    <div class="grid-background"></div>

    <!-- 光晕效果 -->
    <div class="glow-orb glow-orb-1"></div>
    <div class="glow-orb glow-orb-2"></div>
    <div class="glow-orb glow-orb-3"></div>

    <!-- 卫星轨道动画 -->
    <div class="orbit" style="top: 10%; right: 5%;"></div>
    <div class="orbit" style="bottom: 20%; left: 5%;" :style="{ animationDuration: '15s' }"></div>

    <!-- 数据流动画 -->
    <div class="data-flow"></div>

    <!-- 扫描线效果 -->
    <div class="scan-line"></div>

    <!-- 首页主体内容 -->
    <div class="home-content">
      <!-- 1. 新版轮播图 -->
      <section class="carousel-container" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
        <!-- Slide 1: 平台核心价值 -->
        <div class="slide" :class="{ active: currentSlide === 0 }">
          <!-- 装饰：数据流光 -->
          <div class="data-flow-container">
            <div class="data-stream" style="left: 10%; animation-duration: 3s; animation-delay: 0s;"></div>
            <div class="data-stream" style="left: 30%; animation-duration: 4s; animation-delay: 1s;"></div>
            <div class="data-stream" style="left: 70%; animation-duration: 2.5s; animation-delay: 2s;"></div>
            <div class="data-stream" style="left: 90%; animation-duration: 3.5s; animation-delay: 0.5s;"></div>
          </div>

          <div class="bg-image" :style="{ backgroundImage: `url(${carouselImages.slide1})` }"></div>
          <div class="overlay-gradient"></div>
          <div class="content-wrapper">
            <div class="slide-1-content">
              <h1 class="main-title text-gradient">国家级遥感数据<br>大气校正智能处理平台</h1>
              <h2 class="sub-title">融合中科院20年遥感研究成果 · 支持22颗国产卫星</h2>
              <div class="tags-row">
                <span class="tech-pill">自研辐射传输模型</span>
                <span class="tech-pill">自动化处理</span>
                <span class="tech-pill">一站式解决方案</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Slide 2: 应用场景与优势 -->
        <div class="slide" :class="{ active: currentSlide === 1 }">
          <!-- 分屏背景 -->
          <div class="split-bg-grid">
            <div class="split-bg-item" :style="{ backgroundImage: `url(${carouselImages.slide2_1})` }"></div>
            <div class="split-bg-item" :style="{ backgroundImage: `url(${carouselImages.slide2_2})` }"></div>
            <div class="split-bg-item" :style="{ backgroundImage: `url(${carouselImages.slide2_3})` }"></div>
         
          </div>
          <div class="slide-2-overlay"></div>
          
          <div class="content-wrapper">
            <div class="slide-2-layout">
              <h1 class="main-title text-glow">五大应用领域 · 全方位遥感解决方案</h1>
              
              <ul class="app-list-horizontal">
                <li><span class="check-icon">✓</span> 生态环境监测</li>
                <li><span class="check-icon">✓</span> 农业监测与作物估产</li>
                <li><span class="check-icon">✓</span> 水质监测与水资源管理</li>
                <li><span class="check-icon">✓</span> 城市规划与土地利用</li>
                <li><span class="check-icon">✓</span> 地质调查与矿物勘探</li>
              </ul>

              <div class="tech-stats-bar-wide">
                <div class="tech-stat-col">
                  <span class="ts-title">使用模型</span>
                  <span class="ts-value">自研辐射传输模型<br><span style="font-size:12px; opacity:0.8;">支持多种大气情景/气溶胶模式</span></span>
                </div>
                <div class="tech-stat-col">
                  <span class="ts-title">光谱通道支持</span>
                  <span class="ts-value">20余颗卫星 / 40+载荷<br><span style="font-size:12px; opacity:0.8;">全色/多波段通道支持</span></span>
                </div>
                <div class="tech-stat-col">
                  <span class="ts-title">辐射校正精度</span>
                  <span class="ts-value">反射率误差<br><span class="ts-highlight">绝对≤0.03 / 相对≤10%</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Slide 3: 五大软件矩阵 -->
        <div class="slide" :class="{ active: currentSlide === 2 }">
          <div class="bg-image" :style="{ backgroundImage: `url(${carouselImages.slide3})` }"></div>
          <div class="overlay-gradient" style="background: radial-gradient(circle at center, rgba(5,5,8,0.85) 0%, rgba(0,0,0,0.95) 100%);"></div>
          <div class="slide-3-bg-decor"></div>
          <div class="orbital-ring"></div>
          
          <div class="content-wrapper" style="padding: 0 50px;">
            <div class="slide-3-layout">
              <h1 class="main-title text-gradient" style="font-size: 36px; margin-bottom: 20px; margin-top: 0; font-weight: 700;">五大专业软件 · 支持22颗国产卫星</h1>
              
              <div class="matrix-container">
                <div class="matrix-row-top">
                  <div class="sw-card-new">
                    <div class="sw-header">
                      <span class="sw-name">GAC_MSS</span>
                      <span class="sw-type">国产陆地卫星</span>
                    </div>
                    <div class="sw-details">
                      <span class="detail-item">22颗卫星</span>
                      <span class="detail-item">59类影像</span>
                    </div>
                  </div>
                  <div class="sw-card-new">
                    <div class="sw-header">
                      <span class="sw-name">GAC_PMS</span>
                      <span class="sw-type">全色多光谱</span>
                    </div>
                    <div class="sw-details">
                      <span class="detail-item">11颗卫星</span>
                      <span class="detail-item">36类影像</span>
                      <span class="detail-item" style="color: var(--secondary); font-weight: bold;">图像融合</span>
                    </div>
                  </div>
                  <div class="sw-card-new">
                    <div class="sw-header">
                      <span class="sw-name">GAC_CCD</span>
                      <span class="sw-type">16米多光谱</span>
                    </div>
                    <div class="sw-details">
                      <span class="detail-item">4颗卫星</span>
                      <span class="detail-item">13类影像</span>
                      <span class="detail-item" style="color: var(--secondary); font-weight: bold;">批处理</span>
                    </div>
                  </div>
                </div>
                
                <div class="matrix-row-bottom">
                  <div class="sw-card-new" style="width: 48%;">
                    <div class="sw-header">
                      <span class="sw-name">GAC_AHSI_Water</span>
                      <span class="sw-type">高光谱 (400-1000nm)</span>
                    </div>
                    <div class="sw-details">
                      <span class="detail-item">水体监测专用</span>
                      <span class="detail-item">150波段</span>
                    </div>
                  </div>
                  <div class="sw-card-new" style="width: 48%;">
                    <div class="sw-header">
                      <span class="sw-name">GAC_AHSI_Mineral</span>
                      <span class="sw-type">高光谱 (400-2500nm)</span>
                    </div>
                    <div class="sw-details">
                      <span class="detail-item">矿物勘探专用</span>
                      <span class="detail-item">330波段</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="feature-tags-container">
                <span class="feature-capsule">辐射定标</span>
                <span class="feature-capsule">大气校正</span>
                <span class="feature-capsule">几何校正</span>
                <span class="feature-capsule">图像融合</span>
                <span class="feature-capsule">一站式处理</span>
                <span class="feature-capsule">批处理</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 导航按钮 -->
        <button class="nav-btn prev-btn" @click="prevSlide">&#10094;</button>
        <button class="nav-btn next-btn" @click="nextSlide">&#10095;</button>

        <!-- 指示器 -->
        <div class="indicators">
          <div class="dot" :class="{ active: currentSlide === 0 }" @click="goToSlide(0)"></div>
          <div class="dot" :class="{ active: currentSlide === 1 }" @click="goToSlide(1)"></div>
          <div class="dot" :class="{ active: currentSlide === 2 }" @click="goToSlide(2)"></div>
        </div>
      </section>

      <!-- 2. 核心下载区 -->
      <section class="download-area">
        <div class="download-card glass">
          <h2>校正软件</h2>
          <div class="software-types">
            <div class="software-type-item" v-for="software in softwareTypes" :key="software.name">
              <div class="software-info">
                <h3>{{ software.name }}</h3>
                <p>{{ software.description }}</p>
              </div>
            </div>
          </div>
          <button class="download-btn" @click="goToDownloadPage">
            查看下载地址
          </button>
        </div>
      </section>

      <!-- 3. 软件介绍卡片区 -->
      <section class="software-cards">
        <h2 class="section-title">软件介绍</h2>
        <div class="cards-grid">
          <div class="software-card" v-for="software in softwareList" :key="software.id">
            <div class="card-header">
              <h3>{{ software.name }}</h3>
              <div class="version-info">
                <span class="version">最新版本：{{ software.latest_version }}</span>
                <span class="date">发布日期：{{ software.release_date }}</span>
              </div>
            </div>
            <div class="card-content">
              <p class="description">{{ software.description }}</p>
              <div class="features">
                <h4>主要功能：</h4>
                <ul>
                  <li v-for="feature in software.features" :key="feature">{{ feature }}</li>
                </ul>
              </div>
            </div>
            <div class="card-footer">
              <button class="card-download-btn" @click="goToDownloadPage">
                查看详情
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- 4. 图文案例区：左图右文 -->
      <!-- <section class="case-area">
        <div class="case-image">
          <img 
            :src="caseData.image_type === 'upload' ? `https://abc.atmcorr.com/api/uploads//cases/${caseData.image_path}` : caseData.image_url" 
            :alt="caseData.title" 
          />
        </div>
        <div class="case-text">
          <h3>{{ caseData.title || '案例展示' }}</h3>
          <p>{{ caseData.short_description || '暂无案例描述' }}</p>
          <div class="case-tags" v-if="caseData.tags">
            <span v-for="(tag, idx) in caseData.tags.split(',')" :key="idx">{{ tag }}</span>
          </div>
          <div class="case-details" v-if="caseData.detail_description">
            <p>{{ caseData.detail_description }}</p>
          </div>
        </div>
      </section> -->

      <!-- 5. 代码教程区 -->
      <section class="tutorial-area">
        <div class="tutorial-flex-row">
          <div class="tutorial-code">
            <img :src="require('@/assets/liucheng.png')" alt="代码截图" />
          </div>
          <div class="tutorial-text">
            <h3>操作教程</h3>
            <ol>
              <li v-for="(step, index) in tutorialData.steps" :key="index">
                <span class="step-number">{{ index + 1 }}.</span>
                {{ step }}
              </li>
            </ol>
          </div>
        </div>
      </section>

      <!-- 6. 行业新闻区（时间轴布局） -->
      <section class="news-area">
        <h3>行业新闻</h3>
        <ul class="timeline">
          <li v-for="news in newsList" :key="news.id">
            <div class="news-date">{{ news.date }}</div>
            <div class="news-content">
              <h4>
                <a :href="news.link" target="_blank" rel="noopener noreferrer">{{ news.title }}</a>
              </h4>
              <p>{{ news.summary || '暂无简要描述' }}</p>
              <span class="news-source" v-if="news.source">来源：{{ news.source }}</span>
            </div>
          </li>
        </ul>
        <router-link to="/news" class="more-news">更多新闻 &raquo;</router-link>
      </section>
    </div>

    <!-- 二维码弹窗 -->
    <div v-if="showQRModal" class="qr-modal-overlay" @click="closeQRModal">
      <div class="qr-modal" @click.stop>
        <div class="qr-modal-header">
          <h3>扫码下载</h3>
          <button class="close-btn" @click="closeQRModal">×</button>
        </div>
        <div class="qr-modal-content">
          <div class="qr-code-container">
            <div v-if="versionInfo && versionInfo.file_type === 'upload'" class="qr-code-image">
              <img 
                :src="`https://abc.atmcorr.com/api/uploads//versions/${versionInfo.file_path}`" 
                :alt="`下载 ${versionInfo.version_number}`"
                @error="handleImageError"
                @load="handleImageLoad"
                @click="previewImage"
                class="download-image"
              />
              <div v-if="imageLoading" class="image-loading">
                <div class="loading-spinner"></div>
                <p>图片加载中...</p>
              </div>
              <div class="image-overlay">
                <span class="preview-hint">点击查看大图</span>
              </div>
            </div>
            <div v-else class="qr-code-placeholder">
              <div class="qr-icon">📱</div>
              <p>二维码加载中...</p>
            </div>
          </div>
          <div class="download-tips">
            <h4>下载提示：</h4>
            <ul>
              <li>下载完成后请按照安装提示进行安装</li>
              <li>如有问题请联系技术支持</li>
            </ul>
          </div>
        </div>
        <div class="qr-modal-footer">
          <button class="cancel-btn" @click="closeQRModal">取消</button>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <div v-if="showImagePreview" class="image-preview-overlay" @click="closeImagePreview">
      <div class="image-preview-modal" @click.stop>
        <div class="image-preview-header">
          <h3>图片预览</h3>
          <button class="close-btn" @click="closeImagePreview">×</button>
        </div>
        <div class="image-preview-content">
          <img 
            v-if="versionInfo && versionInfo.file_type === 'upload'"
            :src="`https://abc.atmcorr.com/api/uploads//versions/${versionInfo.file_path}`" 
            :alt="`下载 ${versionInfo.version_number}`"
            class="preview-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import api from '@/utils/axios';
import { ElMessage } from 'element-plus'
import { mapState } from 'vuex'

export default {
  name: "Home",
  data() {
    return {
      currentSlide: 0,
      autoPlayInterval: null,
      loading: false,
      // 轮播图图片路径
      carouselImages: {
        slide1: require('@/assets/lunbo/lunbo1.jpg'),
        slide2_1: require('@/assets/lunbo/lunbo2.1.jpg'),
        slide2_2: require('@/assets/lunbo/lunbo2.2.jpg'),
        slide2_3: require('@/assets/lunbo/lunbo2.3.jpg'),
        slide3: require('@/assets/lunbo/lunbo3.jpg')
      },
      versionInfo: {
        version_number: "",
        release_date: "",
        update_log: "",
        file_path: "",
        file_type: ""
      },
      versionList: [],
      // 软件类型列表
      softwareTypes: [
        {
          name: "GAC_MSS国产陆地卫星",
          icon: "🛰️",
          description: "辐射校正软件"
        },
        {
          name: "GAC_PMS国产全色多光谱卫星",
          icon: "📡",
          description: "辐射校正软件"
        },
        {
          name: "GAC_CCD国产16米多光谱卫星",
          icon: "🛸",
          description: "辐射校正软件"
        },
        {
          name: "GAC_AHSI_Water国产高光谱卫星（400-1000nm）",
          icon: "💧",
          description: "辐射校正软件"
        },
        {
          name: "GAC_AHSI_Mineral国产高光谱卫星（400-2500nm）",
          icon: "⛏️",
          description: "辐射校正软件"
        }
      ],
      // 软件详细介绍列表
      softwareList: [
        {
          id: 1,
          name: "GAC_MSS",
          latest_version: "v2.1.0",
          release_date: "2024-01-15",
          description: "可实现国产陆地卫星的辐射校正，包括辐射定标、大气校正、几何校正和一站式处理。",
          features: [
            "辐射定标",
            "大气校正", 
            "几何校正",
            "一站式处理"
          ]
        },
        {
          id: 2,
          name: "GAC_PMS",
          latest_version: "v1.8.0",
          release_date: "2024-01-10",
          description: "可实现多个国产全色多光谱卫星的辐射校正，包括辐射定标、大气校正、几何校正、图像融合、一站式处理、图像镶嵌、辐射批处理等功能。",
          features: [
            "辐射定标",
            "大气校正",
            "几何校正",
            "图像融合",
            "一站式处理",
            "图像镶嵌",
            "辐射批处理"
          ]
        },
        {
          id: 3,
          name: "GAC_CCD",
          latest_version: "v1.5.0",
          release_date: "2024-01-08",
          description: "可实现多个国产16米多光谱卫星的辐射校正，包括辐射定标、大气校正、几何校正、一站式处理、图像镶嵌、辐射批处理等功能。",
          features: [
            "辐射定标",
            "大气校正",
            "几何校正",
            "一站式处理",
            "图像镶嵌",
            "辐射批处理"
          ]
        },
        {
          id: 4,
          name: "GAC_AHSI_Water",
          latest_version: "v1.2.0",
          release_date: "2024-01-05",
          description: "可实现国产高光谱卫星（400-1000nm）的辐射校正，包括辐射定标、大气校正、几何校正、一站式处理、图像镶嵌、辐射批处理等功能。",
          features: [
            "辐射定标",
            "大气校正",
            "几何校正",
            "一站式处理",
            "图像镶嵌",
            "辐射批处理",
            "400-1000nm光谱范围"
          ]
        },
        {
          id: 5,
          name: "GAC_AHSI_Mineral",
          latest_version: "v1.0.0",
          release_date: "2024-01-01",
          description: "可实现国产高光谱卫星（400-2500nm）的辐射校正，包括辐射定标、大气校正、几何校正、一站式处理、图像镶嵌、辐射批处理等功能。",
          features: [
            "辐射定标",
            "大气校正",
            "几何校正",
            "一站式处理",
            "图像镶嵌",
            "辐射批处理",
            "400-2500nm光谱范围"
          ]
        }
      ],
      caseData: {
        title: "",
        short_description: "",
        detail_description: "",
        image_type: "upload",
        image_path: "",
        image_url: "",
        tags: "",
        id: null
      },
      tutorialData: {
        steps: [
          "下载软件。",
          "解压安装。",
          "完成安装，首次登录需要注册账号。",
          "运行主程序。",
          "查看输出结果。"
        ]
      },
      newsList: [],
      showQRModal: false,
      showImagePreview: false,
      imageLoading: false
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isAuthenticated
    }),
    latestVersions() {
      return this.versionList.slice(0, 3);
    }
  },
  mounted() {
    this.startAutoPlay();
    console.log("Home 页面加载完成");
    this.fetchVersions();
    this.fetchNews();
    this.fetchRandomCase();
    this.fetchAllSoftwareVersions();
  },
  beforeUnmount() {
    this.stopAutoPlay();
  },

  methods: {
    // 生成粒子样式
    getParticleStyle(index) {
      const size = Math.random() * 3 + 1;
      const left = Math.random() * 100;
      const animationDuration = Math.random() * 20 + 10;
      const animationDelay = Math.random() * 5;
      const opacity = Math.random() * 0.5 + 0.3;
      
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        animationDuration: `${animationDuration}s`,
        animationDelay: `${animationDelay}s`,
        opacity: opacity
      };
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    },

    async fetchVersions() {
      try {
        this.loading = true;
        const response = await api.get('/downloads/versions');
        console.log('API响应:', response);
        
        // 检查响应数据结构
        const versions = Array.isArray(response) ? response : 
                        (response.data && Array.isArray(response.data) ? response.data : []);
        
        console.log('处理后的版本数据:', versions);
        
        if (versions.length > 0) {
          // 按发布日期排序
          this.versionList = versions.sort((a, b) => 
            new Date(b.release_date) - new Date(a.release_date)
          );
          
          // 设置最新版本信息
          this.versionInfo = {
            id: this.versionList[0].id, // 新增
            version_number: this.versionList[0].version_number || '',
            release_date: this.versionList[0].release_date || '',
            update_log: this.versionList[0].update_log || '',
            file_path: this.versionList[0].file_path || '',
            file_type: this.versionList[0].file_type || ''
          };
          
          console.log('设置的最新版本信息:', this.versionInfo);
          console.log('版本列表:', this.versionList);
        } else {
          console.log('版本数据为空');
          this.$message.warning('暂无版本信息');
        }
      } catch (error) {
        console.error('获取版本信息失败:', error);
        this.$message.error(error.response?.data?.message || '获取版本信息失败');
      } finally {
        this.loading = false;
      }
    },

    async handleDownload() {
      if (!this.isLoggedIn) {
        ElMessage.warning('请先登录后再下载');
        this.$router.push('/login');
        return;
      }

      // 打印 versionInfo
      console.log('versionInfo:', this.versionInfo);

      try {
        // 先记录下载信息
        const res = await api.post('/downloads/record', {
          version_id: this.versionInfo.id
        });
        console.log('下载记录成功', res);

        // 判断文件类型
        if (this.versionInfo.file_type === 'upload') {
          // 上传的文件，弹二维码弹窗
          this.showQRModal = true;
          this.imageLoading = true;
        } else {
          // 外部链接，直接跳转下载
          window.location.href = this.versionInfo.file_path;
          ElMessage.success('开始下载...');
        }
      } catch (error) {
        console.error('记录下载信息失败:', error);
        ElMessage.error('下载记录失败，请稍后重试');
      }
    },

    // 轮播图控制方法
    showSlide(index) {
      if (index >= 3) this.currentSlide = 0;
      else if (index < 0) this.currentSlide = 2;
      else this.currentSlide = index;
    },
    nextSlide() {
      this.showSlide(this.currentSlide + 1);
    },
    prevSlide() {
      this.showSlide(this.currentSlide - 1);
    },
    goToSlide(index) {
      this.showSlide(index);
      this.resetAutoPlay();
    },
    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.nextSlide();
      }, 4000);
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    },

    async fetchNews() {
      try {
        const response = await api.get('/news');
        // 检查响应数据结构
        const newsData = Array.isArray(response) ? response : 
                        (response.data && Array.isArray(response.data) ? response.data : []);
        
        this.newsList = newsData.map(news => ({
          ...news,
          date: this.formatNewsDate(news.created_at)
        }));
      } catch (error) {
        console.error('获取新闻列表失败:', error);
        ElMessage.error('获取新闻列表失败');
      }
    },

    formatNewsDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    },

    async fetchRandomCase() {
      try {
        const response = await api.get('/cases');
        const cases = Array.isArray(response) ? response : 
                     (response.data && Array.isArray(response.data) ? response.data : []);
        
        if (cases.length > 0) {
          // 随机选择一个案例
          const randomIndex = Math.floor(Math.random() * cases.length);
          const randomCase = cases[randomIndex];
          
          this.caseData = {
            title: randomCase.title,
            short_description: randomCase.short_description,
            detail_description: randomCase.detail_description,
            image_type: randomCase.image_type,
            image_path: randomCase.image_path,
            image_url: randomCase.image_url,
            tags: randomCase.tags,
            id: randomCase.id
          };
        }
      } catch (error) {
        console.error('获取随机案例失败:', error);
        ElMessage.error('获取随机案例失败');
      }
    },

    async fetchAllSoftwareVersions() {
      try {
        // 为每个软件获取最新版本
        const promises = this.softwareList.map(async (software) => {
          try {
            const response = await api.get(`/downloads/versions?software_name=${software.name}`);
            const versions = Array.isArray(response.data) ? response.data : 
                           Array.isArray(response) ? response : [];
            
            if (versions.length > 0) {
              // 按发布日期排序，获取最新版本
              const sortedVersions = versions.sort((a, b) => 
                new Date(b.release_date) - new Date(a.release_date)
              );
              
              // 更新软件列表中的版本信息
              software.latest_version = sortedVersions[0].version_number;
              software.release_date = this.formatDate(sortedVersions[0].release_date);
            }
          } catch (error) {
            console.error(`获取${software.name}版本失败:`, error);
          }
        });
        
        await Promise.all(promises);
        console.log('所有软件版本更新完成:', this.softwareList);
      } catch (error) {
        console.error('获取软件版本失败:', error);
      }
    },

    handleImageError(event) {
      console.error('图片加载失败:', event);
      this.imageLoading = false;
    },

    handleImageLoad() {
      this.imageLoading = false;
    },

    previewImage() {
      this.showQRModal = false;
      this.showImagePreview = true;
    },

    closeQRModal() {
      this.showQRModal = false;
    },

    closeImagePreview() {
      this.showImagePreview = false;
    },

    goToDownloadPage() {
      this.$router.push('/download');
    }
  }
}
</script>

<style scoped>
/* ========== 字体导入 ========== */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&family=Space+Grotesk:wght@400;500;600;700&family=Noto+Sans+SC:wght@300;400;500;600;700;900&display=swap');

/* ========== CSS变量定义 ========== */
:root {
  --bg-dark: #0A0A0F;
  --bg-darker: #050507;
  --primary: #00B4FF;
  --secondary: #00F7FF;
  --accent: #FF00FF;
  --text-primary: #E0E0FF;
  --text-secondary: #B0B0FF;
  --text-dim: #B0B0FF;
  --text-main: #FFFFFF;
  --text-sub: #E0E0FF;
  --card-bg: rgba(10, 10, 15, 0.8);
  --quantum-glow: linear-gradient(135deg, var(--primary), var(--secondary));
}

/* ========== 整体布局 ========== */
.home-container {
  position: relative;
  min-height: 100vh;
  background: #000000;
  overflow-x: hidden;
}

/* 背景层1：深色渐变基础 */
.bg-layer-1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(ellipse at top, #0a0e27 0%, #000000 50%, #000000 100%);
  z-index: 0;
  pointer-events: none;
}

/* 背景层2：动态渐变光晕 */
.bg-layer-2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 20% 30%, rgba(0, 180, 255, 0.08) 0%, transparent 40%),
    radial-gradient(circle at 80% 70%, rgba(0, 247, 255, 0.06) 0%, transparent 40%),
    radial-gradient(circle at 50% 50%, rgba(138, 43, 226, 0.04) 0%, transparent 50%);
  z-index: 0;
  pointer-events: none;
  animation: bgPulse 15s ease-in-out infinite;
}

@keyframes bgPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* 背景层3：噪点纹理 */
.bg-layer-3 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 180, 255, 0.03) 2px, rgba(0, 180, 255, 0.03) 4px),
    repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(0, 180, 255, 0.03) 2px, rgba(0, 180, 255, 0.03) 4px);
  z-index: 0;
  pointer-events: none;
  opacity: 0.3;
}

/* 网格背景 */
.grid-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 180, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 180, 255, 0.1) 1px, transparent 1px);
  background-size: 100px 100px;
  z-index: 0;
  pointer-events: none;
  opacity: 0.15;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(100px, 100px); }
}

/* 动态粒子效果 */
.particles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  overflow: hidden;
}

.particle {
  position: absolute;
  background: var(--primary);
  border-radius: 50%;
  box-shadow: 0 0 10px var(--primary);
  animation: particleFloat linear infinite;
  top: -10px;
}

@keyframes particleFloat {
  0% {
    transform: translateY(0) translateX(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) translateX(50px);
    opacity: 0;
  }
}

/* 光晕效果 */
.glow-orb {
  position: fixed;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  z-index: 0;
  opacity: 0.4;
}

.glow-orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(0, 180, 255, 0.3) 0%, transparent 70%);
  top: -100px;
  right: -100px;
  animation: glowFloat1 20s ease-in-out infinite;
}

.glow-orb-2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(0, 247, 255, 0.2) 0%, transparent 70%);
  bottom: -150px;
  left: -150px;
  animation: glowFloat2 25s ease-in-out infinite;
}

.glow-orb-3 {
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(138, 43, 226, 0.2) 0%, transparent 70%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: glowFloat3 30s ease-in-out infinite;
}

@keyframes glowFloat1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-100px, 100px); }
}

@keyframes glowFloat2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(100px, -100px); }
}

@keyframes glowFloat3 {
  0%, 100% { transform: translate(-50%, -50%) scale(1); }
  50% { transform: translate(-50%, -50%) scale(1.2); }
}

/* 扫描线效果 */
.scan-line {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(0, 180, 255, 0.8) 50%, 
    transparent 100%);
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.8);
  z-index: 1;
  pointer-events: none;
  animation: scanDown 8s linear infinite;
}

@keyframes scanDown {
  0% { transform: translateY(0); opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { transform: translateY(100vh); opacity: 0; }
}

/* 首页内容 */
.home-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ========== 1. 新版轮播图样式 ========== */
.carousel-container {
  position: relative;
  width: 1200px;
  height: 450px;
  background-color: var(--bg-dark);
  overflow: hidden;
  box-shadow: 0 0 50px rgba(0, 180, 255, 0.15);
  border: 1px solid rgba(0, 180, 255, 0.2);
  border-radius: 4px;
  margin: 10px;
}

/* 幻灯片基础样式 */
.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out, transform 1s ease-in-out;
  transform: scale(1.05);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  overflow: hidden;
}

.slide.active {
  opacity: 1;
  transform: scale(1);
  z-index: 2;
}

/* 普通背景图模式 */
.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 0;
}

/* 深空遮罩 */
.overlay-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(5,5,7,0.4) 0%, rgba(5,5,7,0.95) 90%);
  z-index: 1;
  pointer-events: none;
}

.content-wrapper {
  position: relative;
  z-index: 10;
  width: 100%;
  padding: 0 60px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* 通用字体 */
h1.main-title {
  font-family: 'Orbitron', 'Noto Sans SC', sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 15px;
  letter-spacing: 2px;
}

h2.sub-title {
  font-size: 20px;
  color: var(--text-sub);
  font-weight: 300;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-shadow: 0 0 10px rgba(224, 224, 255, 0.2);
}

.text-gradient {
  background: linear-gradient(90deg, var(--primary) 0%, var(--secondary) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 0 15px rgba(0, 180, 255, 0.6));
}

.text-glow {
  text-shadow: 0 0 10px var(--primary), 0 0 20px var(--secondary);
}

/* Slide 1 样式 */
.slide-1-content {
  padding-left: 20px;
  max-width: 800px;
  position: relative;
  z-index: 20;
}

/* 数据流光特效 */
.data-flow-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  pointer-events: none;
  overflow: hidden;
}

.data-stream {
  position: absolute;
  width: 2px;
  height: 100px;
  background: linear-gradient(to bottom, transparent, var(--secondary), transparent);
  opacity: 0.6;
  animation: dataFall linear infinite;
}

@keyframes dataFall {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    transform: translateY(450px);
    opacity: 0;
  }
}

.tags-row {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.tech-pill {
  padding: 8px 20px;
  border: 1px solid rgba(0, 180, 255, 0.5);
  background: rgba(0, 180, 255, 0.15);
  border-radius: 50px;
  color: var(--secondary);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(5px);
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.2);
  transition: transform 0.3s;
}

.tech-pill:hover {
  transform: translateY(-2px);
  background: rgba(0, 180, 255, 0.25);
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.4);
}

/* Slide 2: 分屏背景与布局 */
.split-bg-grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  z-index: 0;
  filter: brightness(0.6) contrast(1.1);
}

.split-bg-item {
  background-size: cover;
  background-position: center;
  position: relative;
  border: 1px solid rgba(0, 180, 255, 0.1);
}

.split-bg-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0,180,255,0.1) 0%, transparent 20%);
  pointer-events: none;
}

.slide-2-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(5, 5, 8, 0.85) 30%, rgba(5, 5, 8, 0.6) 100%);
  z-index: 1;
}

.slide-2-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
}

.app-list-horizontal {
  display: flex;
  gap: 25px;
  list-style: none;
  margin: 25px 0;
  flex-wrap: wrap;
  justify-content: center;
}

.app-list-horizontal li {
  font-size: 16px;
  color: var(--text-dim);
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.3);
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid rgba(255,255,255,0.1);
}

.check-icon {
  color: var(--secondary);
  margin-right: 10px;
  font-weight: bold;
  text-shadow: 0 0 8px var(--secondary);
}

/* Slide 2 底部技术参数栏 */
.tech-stats-bar-wide {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;
  margin-top: 20px;
  width: 100%;
  background: rgba(0, 180, 255, 0.05);
  border-top: 1px solid rgba(0, 180, 255, 0.3);
  border-bottom: 1px solid rgba(0, 180, 255, 0.3);
  padding: 20px 0;
  backdrop-filter: blur(5px);
}

.tech-stat-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-right: 1px solid rgba(255,255,255,0.1);
}

.tech-stat-col:last-child {
  border-right: none;
}

.ts-title {
  color: var(--text-dim);
  font-size: 14px;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.ts-value {
  font-family: 'Orbitron', 'Noto Sans SC';
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  max-width: 80%;
}

.ts-highlight {
  color: var(--secondary);
  font-weight: 700;
  text-shadow: 0 0 5px rgba(0, 247, 255, 0.4);
}

/* Slide 3: 五大软件矩阵 */
.slide-3-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  justify-content: center;
  position: relative;
}

/* 装饰背景: 网格与轨道 */
.slide-3-bg-decor {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 180, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 180, 255, 0.05) 1px, transparent 1px);
  background-size: 60px 60px;
  z-index: -1;
  pointer-events: none;
}

.orbital-ring {
  position: absolute;
  width: 900px;
  height: 900px;
  border: 1px dashed rgba(0, 247, 255, 0.1);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
  animation: spin 80s linear infinite;
}

.orbital-ring::before {
  content: '';
  position: absolute;
  top: -5px;
  left: 50%;
  width: 8px;
  height: 8px;
  background: var(--secondary);
  border-radius: 50%;
  box-shadow: 0 0 10px var(--secondary);
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

/* 软件矩阵网格 */
.matrix-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 1100px;
  margin-bottom: 15px;
  position: relative;
}

.matrix-row-top {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.matrix-row-bottom {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.sw-card-new {
  background: rgba(12, 20, 35, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 180, 255, 0.4);
  border-radius: 6px;
  padding: 15px 18px;
  position: relative;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 85px;
  justify-content: center;
}

.sw-card-new:hover {
  transform: translateY(-5px);
  border-color: var(--secondary);
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.25);
  background: rgba(15, 25, 40, 0.9);
}

.sw-card-new::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 20px;
  height: 1px;
  background: linear-gradient(90deg, rgba(0,180,255,0.5), transparent);
  right: -21px;
  pointer-events: none;
  opacity: 0.5;
}

.sw-card-new:last-child::after {
  display: none;
}

.sw-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  padding-bottom: 6px;
}

.sw-name {
  font-family: 'Orbitron';
  color: var(--primary);
  font-size: 18px;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
  letter-spacing: 0.5px;
}

.sw-type {
  font-size: 13px;
  color: #fff;
  opacity: 0.95;
  font-weight: 400;
}

.sw-details {
  font-size: 13px;
  color: var(--text-dim);
  line-height: 1.5;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.detail-item {
  background: rgba(255, 255, 255, 0.1);
  padding: 4px 12px;
  border-radius: 4px;
  font-weight: 400;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

/* 底部功能标签 */
.feature-tags-container {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 12px;
}

.feature-capsule {
  padding: 10px 28px;
  font-size: 15px;
  color: #fff;
  border: 1px solid var(--secondary);
  background: rgba(0, 180, 255, 0.2);
  border-radius: 25px;
  box-shadow: 0 0 15px rgba(0, 247, 255, 0.2);
  font-weight: 600;
  letter-spacing: 1.2px;
  backdrop-filter: blur(6px);
  transition: all 0.3s ease;
}

.feature-capsule:hover {
  background: rgba(0, 180, 255, 0.3);
  box-shadow: 0 0 20px rgba(0, 247, 255, 0.4);
  transform: translateY(-2px);
}

/* 导航按钮 */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(0, 180, 255, 0.2);
  border: 1px solid rgba(0, 180, 255, 0.3);
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 20;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.nav-btn:hover {
  background: rgba(0, 180, 255, 0.4);
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.5);
  border-color: var(--secondary);
}

.prev-btn {
  left: 20px;
}

.next-btn {
  right: 20px;
}

/* 指示器 */
.indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  z-index: 20;
}

.dot {
  width: 10px;
  height: 10px;
  background: rgba(255,255,255,0.3);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
}

.dot.active {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  box-shadow: 0 0 10px var(--secondary);
  transform: scale(1.2);
}

/* ========== 2. 核心下载区 ========== */
.download-area {
  margin: 20px 0;
  width: 90%;
  max-width: 1200px;
  display: flex;
  justify-content: center;
}

.download-card {
  background: var(--card-bg);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  text-align: center;
  border: 1px solid rgba(0, 180, 255, 0.2);
  position: relative;
  overflow: hidden;
  width: 100%;
}

.software-types {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin: 25px 0;
}

.software-type-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: rgba(0, 180, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  transition: all 0.3s ease;
}

.software-type-item:hover {
  background: rgba(0, 180, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 180, 255, 0.2);
}

.software-info h3 {
  color: var(--primary);
  margin: 0 0 3px 0;
  font-size: 0.85rem;
  text-shadow: 0 0 8px rgba(0, 180, 255, 0.5);
  line-height: 1.2;
}

.software-info p {
  color: var(--text-secondary);
  margin: 0;
  font-size: 0.75rem;
}

.download-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(0, 180, 255, 0.1), transparent);
  transform: translateX(-100%);
  animation: shine 3s infinite;
}

@keyframes shine {
  100% {
    transform: translateX(100%);
  }
}

.download-card h2 {
  color: var(--primary);
  margin-bottom: 10px;
  font-size: 1.8rem;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.download-card p {
  color: var(--text-secondary);
  margin-bottom: 10px;
  font-size: 1rem;
}

.download-desc {
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: var(--text-primary);
}

.download-btn {
  background: var(--quantum-glow);
  color: var(--text-primary);
  padding: 15px 40px;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
}

.download-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: 0.5s;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 20px var(--primary);
}

.download-btn:hover::before {
  left: 100%;
}

/* ========== 3. 软件介绍卡片区 ========== */
.software-cards {
  width: 90%;
  max-width: 1400px;
  margin:  auto;
}

.section-title {
  text-align: center;
  color: var(--primary);
  font-size: 2.5rem;
  margin-bottom: 40px;
  text-shadow: 0 0 20px rgba(0, 180, 255, 0.5);
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.software-card {
  background: var(--card-bg);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.software-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 40px rgba(0, 180, 255, 0.2);
  border-color: rgba(0, 180, 255, 0.4);
}

.software-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(0, 180, 255, 0.05), transparent);
  transform: translateX(-100%);
  animation: shine 4s infinite;
}

.card-header {
  padding: 15px 20px 10px 20px;
  border-bottom: 1px solid rgba(0, 180, 255, 0.2);
  background: linear-gradient(135deg, rgba(0, 180, 255, 0.1), rgba(0, 247, 255, 0.05));
}

.card-header h3 {
  color: var(--primary);
  font-size: 1.1rem;
  margin: 0 0 10px 0;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
  line-height: 1.3;
}

.version-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.version-info span {
  color: var(--text-secondary);
  font-size: 0.8rem;
  padding: 3px 8px;
  background: rgba(0, 180, 255, 0.1);
  border-radius: 4px;
  border: 1px solid rgba(0, 180, 255, 0.2);
}

.card-content {
  padding: 15px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.description {
  color: var(--text-primary);
  line-height: 1.5;
  margin-bottom: 15px;
  font-size: 0.9rem;
  text-indent: 2em;
  flex: 1;
}

.features {
  margin-top: auto;
}

.features h4 {
  color: var(--primary);
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.features ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.features li {
  color: var(--text-secondary);
  padding: 4px 8px;
  font-size: 0.85rem;
  background: rgba(0, 180, 255, 0.1);
  border-radius: 4px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  white-space: nowrap;
}

.card-footer {
  padding: 10px 20px 15px 20px;
  border-top: 1px solid rgba(0, 180, 255, 0.2);
  background: rgba(0, 0, 0, 0.1);
  margin-top: auto;
}

.card-download-btn {
  width: 100%;
  padding: 8px 16px;
  background: var(--quantum-glow);
  color: var(--text-primary);
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
  position: relative;
  overflow: hidden;
}

.card-download-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: 0.5s;
}

.card-download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(0, 180, 255, 0.4);
}

.card-download-btn:hover::before {
  left: 100%;
}


/* ========== 4. 图文案例区 ========== */
.case-area {
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  display: flex;
  gap: 20px;
  align-items: center;
  background: var(--card-bg);
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
}

.case-image {
  flex: 0 0 60%;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

.case-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(0, 180, 255, 0.2), transparent);
  transform: translateX(-100%);
  animation: shine 3s infinite;
}

.case-image img {
  width: 100%;
  border-radius: 8px;
  transition: transform 0.3s;
  filter: brightness(0.8) contrast(1.2);
}

.case-image:hover img {
  transform: scale(1.02);
}

.case-text {
  flex: 0 0 40%;
  text-align: left;
  padding: 20px;
}

.case-text h3 {
  margin-bottom: 15px;
  font-size: 1.8rem;
  color: var(--primary);
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.case-text p {
  color: var(--text-secondary);
  line-height: 1.8;
  font-size: 1.1rem;
  margin-bottom: 15px;
}

.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 15px 0;
}

.case-tags span {
  background: rgba(0, 180, 255, 0.2);
  color: var(--text-primary);
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 0.9rem;
  border: 1px solid rgba(0, 180, 255, 0.3);
  transition: all 0.3s;
}

.case-tags span:hover {
  background: rgba(0, 180, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 0 10px rgba(0, 180, 255, 0.2);
}

.case-details {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 180, 255, 0.2);
}

.case-details p {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--text-secondary);
  opacity: 0.9;
}

/* ========== 5. 代码教程区 ========== */
.tutorial-area {
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  background: var(--card-bg);
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
}

.tutorial-flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}

.tutorial-code {
  flex: 0 0 48%;
  border: 1px solid rgba(0, 180, 255, 0.2);
  padding: 20px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
}

.tutorial-code::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(0, 180, 255, 0.1), transparent);
  transform: translateX(-100%);
  animation: shine 3s infinite;
}

.tutorial-code img {
  width: 100%;
  border-radius: 4px;
  filter: brightness(0.8) contrast(1.2);
}

.tutorial-text {
  flex: 0 0 48%;
  text-align: left;
}

.tutorial-text h3 {
  color: var(--primary);
  margin-bottom: 15px;
  font-size: 1.8rem;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.tutorial-text ol {
  padding-left: 0;
  list-style: none;
}

.tutorial-text li {
  margin-bottom: 15px;
  position: relative;
  padding-left: 30px;
  font-size: 1.1rem;
  color: var(--text-secondary);
}

.tutorial-text li::before {
  content: '>';
  position: absolute;
  left: 0;
  color: var(--primary);
  font-size: 1.2rem;
}

/* ========== 6. 行业新闻区 ========== */
.news-area {
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  text-align: left;
  background: var(--card-bg);
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.1);
  border: 1px solid rgba(0, 180, 255, 0.2);
  backdrop-filter: blur(10px);
}

.news-area h3 {
  color: var(--primary);
  margin-bottom: 20px;
  font-size: 1.8rem;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.timeline {
  list-style: none;
  padding: 0;
  border-left: 2px solid var(--primary);
  margin-left: 20px;
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 0;
  left: -2px;
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, var(--primary), var(--secondary));
  filter: blur(1px);
}

.timeline li {
  margin-bottom: 20px;
  position: relative;
  padding-left: 30px;
}

.timeline li::before {
  content: '';
  position: absolute;
  left: -10px;
  top: 0;
  width: 12px;
  height: 12px;
  background: var(--primary);
  border-radius: 50%;
  box-shadow: 0 0 10px var(--primary);
}

.news-date {
  font-weight: bold;
  color: var(--primary);
  margin-bottom: 8px;
  text-shadow: 0 0 5px rgba(0, 180, 255, 0.5);
}

.news-content {
  position: relative;
  padding: 15px;
  background: rgba(0, 180, 255, 0.05);
  border-radius: 8px;
  margin-bottom: 10px;
  transition: all 0.3s;
}

.news-content:hover {
  background: rgba(0, 180, 255, 0.1);
  transform: translateX(5px);
}

.news-content h4 {
  margin: 0 0 10px 0;
}

.news-content h4 a {
  color: var(--text-primary);
  text-decoration: none;
  transition: all 0.3s;
  font-size: 1.1rem;
}

.news-content h4 a:hover {
  color: var(--secondary);
  text-shadow: 0 0 10px var(--secondary);
}

.news-content p {
  color: var(--text-secondary);
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  line-height: 1.6;
}

.news-source {
  display: inline-block;
  font-size: 0.85rem;
  color: var(--primary);
  opacity: 0.8;
}

.more-news {
  display: inline-block;
  margin-top: 20px;
  color: var(--primary);
  text-decoration: none;
  transition: all 0.3s;
  padding: 10px 20px;
  border: 1px solid rgba(0, 180, 255, 0.3);
  border-radius: 4px;
}

.more-news:hover {
  color: var(--secondary);
  background: rgba(0, 180, 255, 0.1);
  box-shadow: 0 0 15px rgba(0, 180, 255, 0.2);
}

/* ========== 动画效果 ========== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 添加卫星轨道动画 */
@keyframes orbit {
  0% {
    transform: rotate(0deg) translateX(150px) rotate(0deg);
  }
  100% {
    transform: rotate(360deg) translateX(150px) rotate(-360deg);
  }
}

.orbit {
  position: absolute;
  width: 300px;
  height: 300px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  border-radius: 50%;
  animation: orbit 20s linear infinite;
}

.orbit::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background: var(--primary);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 10px var(--primary);
}

/* 添加数据流动画 */
@keyframes dataFlow {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 100% 100%;
  }
}

.data-flow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, 
    transparent 0%,
    rgba(0, 180, 255, 0.1) 25%,
    transparent 50%,
    rgba(0, 247, 255, 0.1) 75%,
    transparent 100%
  );
  background-size: 200% 200%;
  animation: dataFlow 10s linear infinite;
  pointer-events: none;
}

/* ========== 二维码弹窗样式 ========== */
.qr-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.qr-modal {
  background: var(--card-bg);
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(0, 180, 255, 0.3);
  border: 1px solid rgba(0, 180, 255, 0.3);
  backdrop-filter: blur(15px);
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.qr-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 180, 255, 0.2);
  background: linear-gradient(135deg, rgba(0, 180, 255, 0.1), rgba(255, 0, 255, 0.1));
}

.qr-modal-header h3 {
  color: var(--primary);
  margin: 0;
  font-size: 20px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.close-btn {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s;
}

.close-btn:hover {
  background: rgba(255, 0, 0, 0.2);
  color: #ff4444;
  transform: rotate(90deg);
}

.qr-modal-content {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.qr-code-image {
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.2);
  border: 2px solid rgba(0, 180, 255, 0.3);
}

.download-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: rgba(0, 180, 255, 0.05);
  transition: transform 0.3s ease;
}

.download-image:hover {
  transform: scale(1.05);
}

.qr-code-placeholder {
  width: 200px;
  height: 200px;
  border: 2px dashed rgba(0, 180, 255, 0.3);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 180, 255, 0.05);
  color: var(--text-secondary);
}

.qr-icon {
  font-size: 48px;
  margin-bottom: 10px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.download-tips {
  background: rgba(0, 180, 255, 0.05);
  border-radius: 8px;
  padding: 16px;
  border-left: 4px solid var(--primary);
}

.download-tips h4 {
  color: var(--primary);
  margin: 0 0 12px 0;
  font-size: 16px;
}

.download-tips ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.download-tips li {
  color: var(--text-secondary);
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
  font-size: 14px;
}

.download-tips li::before {
  content: '•';
  color: var(--primary);
  position: absolute;
  left: 0;
  font-weight: bold;
}

.qr-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid rgba(0, 180, 255, 0.2);
  background: rgba(0, 0, 0, 0.1);
}

.cancel-btn {
  flex: 1;
  padding: 12px 20px;
  border-radius: 8px;
  border: 1px solid rgba(0, 180, 255, 0.3);
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.cancel-btn:hover {
  background: rgba(255, 0, 0, 0.1);
  border-color: #ff4444;
  color: #ff4444;
}

.image-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
}

.image-loading .loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid rgba(0, 180, 255, 0.1);
  border-radius: 50%;
  border-top: 3px solid var(--primary);
  animation: spin 1s linear infinite;
}

.image-loading p {
  color: var(--text-primary);
  margin-top: 10px;
  font-size: 12px;
}

/* 图片预览弹窗样式 */
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  backdrop-filter: blur(10px);
}

.image-preview-modal {
  background: var(--card-bg);
  border-radius: 16px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 0 40px rgba(0, 180, 255, 0.4);
  border: 1px solid rgba(0, 180, 255, 0.3);
  backdrop-filter: blur(15px);
  animation: modalSlideIn 0.3s ease-out;
}

.image-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 180, 255, 0.2);
  background: linear-gradient(135deg, rgba(0, 180, 255, 0.1), rgba(255, 0, 255, 0.1));
}

.image-preview-header h3 {
  color: var(--primary);
  margin: 0;
  font-size: 20px;
  text-shadow: 0 0 10px rgba(0, 180, 255, 0.5);
}

.image-preview-content {
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  max-height: 70vh;
  overflow: auto;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 180, 255, 0.2);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.qr-code-image:hover .image-overlay {
  opacity: 1;
}

.preview-hint {
  color: var(--text-primary);
  font-size: 14px;
  background: rgba(0, 0, 0, 0.7);
  padding: 8px 12px;
  border-radius: 6px;
  backdrop-filter: blur(5px);
}
</style>